import React, { useState, useEffect } from "react";
import { Switch } from "antd";

const questionCategories = {
  Booking: "Booking",
  Pricing: "Pricing",
  Services: "Services",
  Profiles: "Profiles",
};

// Display-only labels — the enum values above are sent to/compared against
// the API and must not change.
export const categoryLabels = {
  Booking: "Резервации",
  Pricing: "Цени",
  Services: "Услуги",
  Profiles: "Профили",
};

const initialFormData = (item, activeCategory) =>
  item
    ? {
        category: item.category,
        question: {
          en: item?.question?.en || "",
          bg: item?.question?.bg || "",
        },
        answer: {
          en: item?.answer?.en || "",
          bg: item?.answer?.bg || "",
        },
        showOnHomepage: Boolean(item?.showOnHomepage),
      }
    : {
        category: activeCategory
          ? activeCategory
          : questionCategories.Booking,
        question: {
          en: "",
          bg: "",
        },
        answer: {
          en: "",
          bg: "",
        },
        showOnHomepage: false,
      };

export default function FAQForm({ item, onSubmit, activeCategory }) {
  const [formData, setFormData] = useState(
    initialFormData(item, activeCategory)
  );
  const [dirtyFields, setDirtyFields] = useState({
    form: false,
    category: false,
    question: {
      en: false,
      bg: false,
    },
    answer: {
      en: false,
      bg: false,
    },
    showOnHomepage: false,
  });

  const submitForm = () => {
    // BG is the one required language — imports and manual entries routinely
    // land Bulgarian-only, with EN filled in later by the translation pass
    // (DAB-858).
    if (
      formData.question.bg &&
      formData.answer.bg &&
      formData.category
    ) {
      onSubmit(formData);
    } else {
      alert("Моля, попълни българския въпрос, отговор и категория!");
    }
  };

  //Check for dirty fields
  useEffect(() => {
    let initalData = initialFormData(item, activeCategory);

    let dirtyFields = {
      form:
        initalData.question.en !== formData.question.en ||
        initalData.question.bg !== formData.question.bg ||
        initalData.answer.en !== formData.answer.en ||
        initalData.answer.bg !== formData.answer.bg ||
        initalData.category !== formData.category ||
        initalData.showOnHomepage !== formData.showOnHomepage
          ? true
          : false,
      category: initalData.category !== formData.category ? true : false,
      question: {
        en: initalData.question.en !== formData.question.en ? true : false,
        bg: initalData.question.bg !== formData.question.bg ? true : false,
      },
      answer: {
        en: initalData.answer.en !== formData.answer.en ? true : false,
        bg: initalData.answer.bg !== formData.answer.bg ? true : false,
      },
      showOnHomepage: initalData.showOnHomepage !== formData.showOnHomepage,
    };

    setDirtyFields(dirtyFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  return (
    <>
      <div
        style={{
          marginTop: "10px",
          padding: "10px 0",
          maxWidth: "300px",
        }}
      >
        <label for="category">
          <b>Категория: </b>
        </label>
        <select
          name="category"
          style={{
            height: "44px",
            marginLeft: "15px",
            backgroundColor: dirtyFields?.category ? "#F0EAD6" : "white",
            borderRadius: "6px",
            color: "#556ee6ue",
            minWidth: "100px",
            border: "2px solid",
          }}
          value={formData.category}
          onChange={(e) =>
            setFormData({
              ...formData,
              category: e.target.value,
            })
          }
        >
          <option value={questionCategories.Booking}>
            {categoryLabels.Booking}
          </option>
          <option value={questionCategories.Pricing}>
            {categoryLabels.Pricing}
          </option>
          <option value={questionCategories.Services}>
            {categoryLabels.Services}
          </option>
          <option value={questionCategories.Profiles}>
            {categoryLabels.Profiles}
          </option>
        </select>
      </div>
      <div
        style={{
          marginTop: "10px",
          padding: "10px 0",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Switch
          checked={formData.showOnHomepage}
          onChange={(checked) =>
            setFormData({ ...formData, showOnHomepage: checked })
          }
        />
        <label>Показвай на началната</label>
      </div>
      <div
        style={{
          marginTop: "10px",
          padding: "15px",
          border: "1px solid gray",
          boxShadow: "2px 2px",
          borderRadius: "0 8px 0 8px",
        }}
      >
        <h5 style={{ color: "red" }}>Въпрос</h5>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <label for="question-en"> Английски (незадължително):</label>
          <textarea
            id="question-en"
            name="question-en"
            value={formData?.question?.en}
            style={{
              backgroundColor: dirtyFields?.question?.en ? "#F0EAD6" : "white",
            }}
            onChange={(e) =>
              setFormData({
                ...formData,
                question: { ...formData.question, en: e.target.value },
              })
            }
          />
          <br></br>
          <label for="question-bg"> Български:</label>
          <textarea
            id="question-bg"
            name="question-bg"
            value={formData?.question?.bg}
            style={{
              backgroundColor: dirtyFields?.question?.bg ? "#F0EAD6" : "white",
            }}
            onChange={(e) =>
              setFormData({
                ...formData,
                question: { ...formData.question, bg: e.target.value },
              })
            }
          />
        </div>
      </div>
      <div
        style={{
          marginTop: "30px",
          padding: "15px",
          border: "1px solid gray",
          boxShadow: "2px 2px",
          borderRadius: "0 8px 0 8px",
        }}
      >
        <h5 style={{ color: "green" }}>Отговор</h5>
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <label for="answer-en"> Английски (незадължително):</label>
          <textarea
            id="answer-en"
            name="answer-en"
            rows={5}
            value={formData?.answer?.en}
            style={{
              backgroundColor: dirtyFields?.answer?.en ? "#F0EAD6" : "white",
            }}
            onChange={(e) =>
              setFormData({
                ...formData,
                answer: { ...formData.answer, en: e.target.value },
              })
            }
          />
          <br></br>
          <label for="answer-bg"> Български:</label>
          <textarea
            id="answer-bg"
            name="answer-bg"
            rows={5}
            value={formData?.answer?.bg}
            style={{
              backgroundColor: dirtyFields?.answer?.bg ? "#F0EAD6" : "white",
            }}
            onChange={(e) =>
              setFormData({
                ...formData,
                answer: { ...formData.answer, bg: e.target.value },
              })
            }
          />
        </div>
      </div>
      <button
        disabled={!dirtyFields.form}
        style={{
          height: "44px",
          backgroundColor: dirtyFields.form ? "#4CAF50" : "lightgray",
          color: "white",
          fontWeight: "bold",
          borderRadius: "5px",
          margin: "15px 0",
          width: "100%",
        }}
        onClick={submitForm}
      >
        Запази
      </button>
    </>
  );
}
